import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-greet-icon',
  templateUrl: './greet-icon.component.svg',
  styleUrls: ['./greet-icon.component.css'],
})
export class GreetIconComponent {
  @Input() color!: string;
}
